import { Box, Stack, Typography } from '@mui/material';

import CopyToClipboardButton from '../../../components/Clipboard/CopyToClipboardButton';

interface FlowInstanceAttributeItemProps {
	attributeKey: string;
	value: string;
}

export default function FlowInstanceAttributeItem({ attributeKey, value }: FlowInstanceAttributeItemProps) {
	return (
		<Box sx={{ minWidth: 0 }}>
			<Stack direction="row" spacing={0.5} alignItems="center">
				<Typography variant="body2" color="textSecondary" sx={{ fontFamily: 'monospace', fontSize: '0.75rem', wordBreak: 'break-word' }}>
					{attributeKey}
				</Typography>
				<CopyToClipboardButton value={attributeKey} title="Copy attribute key" size="small" iconSize={12} />
			</Stack>
			<Stack
				direction="row"
				spacing={0.5}
				alignItems="center"
				sx={{
					position: 'relative',
					ml: 2,
					mt: 0.25,
					pl: 1.25,
					'&::before': {
						content: '""',
						position: 'absolute',
						left: 0,
						top: -5,
						width: 8,
						height: 14,
						borderLeft: '1px solid',
						borderBottom: '1px solid',
						borderColor: 'divider',
					},
				}}
			>
				<Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.75rem', wordBreak: 'break-word' }}>
					{value}
				</Typography>
				<CopyToClipboardButton value={value} title="Copy attribute value" size="small" iconSize={12} />
			</Stack>
		</Box>
	);
}
